<template>
  <div class="flex w-full flex-col gap-6 p-6" v-if="pageEnabled">
    <nav class="pb-3" aria-label="Breadcrumb">
      <ol class="flex space-x-1 truncate text-xs md:space-x-4 md:text-sm">
        <li>
          <div>
            <router-link to="/" class="text-gray-400 hover:text-gray-400">
              <span v-html="$icons.home"></span>

              <span class="sr-only">Home</span>
            </router-link>
          </div>
        </li>
        <li v-for="(item, i) in breadcrumb" :key="i">
          <div class="flex items-center">
            <span class="text-gray-400" v-html="$icons.chevron_right"></span>

            <router-link
              :to="item.url"
              class="ml-1 text-xs font-medium text-gray-400 hover:text-gray-700 md:ml-4 md:text-sm"
            >
              {{ item.name }}
            </router-link>
          </div>
        </li>
      </ol>
    </nav>
    <div class="mx-auto flex w-2/3 flex-col gap-6">
      <div class="flex items-center justify-between">
        <div>
          <div class="flex items-center gap-4">
            <i v-html="$icons.edit_document"> </i>
            <h3 class="text-2xl font-bold">Pré autorização de operações L&S</h3>
          </div>
          <span class="text-sm text-gray-500 dark:text-gray-400">
            Deixe suas operações L&S pré autorizadas por um prazo determinado.
          </span>
        </div>
      </div>
      <div class="flex w-full flex-col gap-4">
        <div class="grid grid-cols-3 gap-4 text-sm" v-for="item in formFields" :key="item.label">
          <div class="col-span-2">
            <label :for="item.label">
              {{ item.label }}
            </label>
          </div>
          <div class="flex w-full flex-col gap-2">
            <template v-if="item.type === 'search'">
              <ontick-editable-select-component
                forceSelect
                showNoOptionsAlert
                :value="item.value"
                :options="item.searchResults"
                :inputStyles="'dark:bg-ontick-graphite-500 border-0 text-sm h-10 w-full'"
                :icon="$icons.search"
                :placeholder="item.placeholder"
                :showForceSelectError="false"
                @input="item.value = $event.value"
                @selected-from-box="selectedStrategy = $event"
              />
              <!-- <input
                  type="text"
                  class="input !rounded-none !shadow-none"
                  v-model="item.value"
                  :placeholder="item.placeholder"
                  :max="item.max"
                  :min="item.min"
                  @input="searchPartners"
                /> -->
            </template>
            <template v-else-if="item.type === 'currency'">
              <input
                type="text"
                class="input"
                v-model="item.value"
                :placeholder="item.placeholder"
                :max="item.max"
                :min="item.min"
                v-money="money"
              />
              <div v-if="totalAmount">Total: {{ totalAmount | currency }}</div>
            </template>
            <template v-else-if="item.type === 'dropdown'">
              <select class="input" v-model="item.value" :disabled="item.options.length == 0">
                <option value="" selected disabled>Selecione</option>
                <option v-for="option in item.options" :key="option" :value="option">
                  {{ option }}
                </option>
              </select>
            </template>
          </div>
        </div>
      </div>
      <button
        @click="confirm"
        :disabled="buttonDisabled"
        class="dark:disabled:bg-ontick-steel-500 bg-ontick-blue-600 dark:bg-ontick-blue-900 flex h-10 w-full items-center justify-center gap-2 rounded-md px-4 text-sm font-semibold text-white shadow filter transition-all hover:brightness-110 disabled:cursor-not-allowed disabled:filter-none dark:disabled:text-gray-400"
      >
        <span> Autorizar </span>
      </button>
    </div>
    <portal to="modal">
      <ontick-modal-component
        :open="userPinModalIsActive"
        :size="'small'"
        :showCloseButton="false"
        @close="userPinModalIsActive = false"
      >
        <div class="flex flex-col items-center gap-4">
          <div class="text-center">
            <p class="text-2xl">Assinatura eletrônica</p>
            <p class="text-xs">Digite sua assinatura eletrônica de 4 digitos para confirmar esta ação:</p>
          </div>
          <ontick-pin-code-input-component v-model="userPin" />
          <p class="text-xs">
            Esqueceu sua assinatura?
            <a
              href="https://ajuda.ontick.com.br/portal/pt-br/kb/articles/como-gerar-nova-assinatura-eletronica-ontick"
              target="_blank"
              class="text-ontick-blue-600 filter transition-all hover:brightness-125"
            >
              Clique aqui.
            </a>
          </p>
          <button
            @click="createAuth"
            :disabled="userPin.length !== 4"
            class="bg-ontick-blue-800 disabled:bg-ontick-steel-500 w-full rounded-md py-2 font-semibold filter transition-all hover:brightness-125 disabled:cursor-not-allowed disabled:filter-none"
          >
            Autorizar
          </button>
        </div>
      </ontick-modal-component>
    </portal>
  </div>
</template>

<script>
import { VMoney } from "v-money";
import { mapGetters } from "vuex";
import ontickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";
import OntickModalComponent from "../../../shared/components/basic/ontick-modal.component.vue";
import OntickPinCodeInputComponent from "../../../shared/components/basic/ontick-pin-code-input.component.vue";
export default {
  directives: {
    money: VMoney,
  },

  components: {
    ontickEditableSelectComponent,
    OntickModalComponent,
    OntickPinCodeInputComponent,
  },

  data() {
    return {
      formFields: [
        {
          label: "Estratégia",
          type: "search",
          value: "",
          placeholder: "Buscar",
          searchResults: [],
        },
        // {
        //   label: "Volume total destinado à operações (em reais):",
        //   type: "currency",
        //   value: "",
        //   placeholder: "R$ 0,00",
        // },
        // {
        //   label: "Validade das autorizações (em dias):",
        //   type: "number",
        //   value: undefined,
        //   placeholder: "1-90",
        //   max: 90,
        //   min: 1,
        //   footerInfo: "Até 24/06/2023",
        //   showFooterInfo: true,
        // },
        {
          label: "Limite máximo de operações simultâneas:",
          type: "dropdown",
          value: "",
          placeholder: "Selecione",
          options: [],
        },
        {
          label: "Limite máximo por operação (em reais):",
          type: "currency",
          value: "",
          placeholder: "R$ 0,00",
        },
      ],
      results: [],
      selectedStrategy: "",
      userPinModalIsActive: false,
      userPin: "",
    };
  },

  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getConfigs: "config/getConfigs",
    }),
    pageEnabled() {
      return this.getConfigs.side_menus.map((item) => item.menu_name).includes("Long & Short");
    },
    totalAmount() {
      let trades = this.formFields.find((item) => item.label === "Limite máximo de operações simultâneas:").value;
      let maxPerTrade = Number(
        this.formFields
          .find((item) => item.label === "Limite máximo por operação (em reais):")
          .value.replaceAll("R$ ", "")
          .replaceAll(".", "")
      );
      return trades * maxPerTrade;
    },
    strategyInfo() {
      return this.results?.find((item) => item.strategy_code === this.selectedStrategy);
    },
    buttonDisabled() {
      const arr = this.formFields.map((item) => {
        if (item.value === "R$ 0") {
          return false;
        } else {
          return !!item.value;
        }
      });
      return arr.some((item) => item === false);
    },
    breadcrumb() {
      return [
        {
          name: "Long & Short",
          url: { name: "Long & Short" },
        },
        {
          name: "Pré-autorização",
          url: { name: "Pré-autorização Long & Short" },
        },
        {
          name: "Nova autorização",
          url: { name: "Nova autorização Long & Short" },
        },
      ];
    },
    valuesToSend() {
      return {
        account_id: this.getSelectedAccount.account_id,
        user_max_positions: this.getValue("Limite máximo de operações simultâneas:"),
        user_trade_volume: Number(
          this.getValue("Limite máximo por operação (em reais):")
            ?.replaceAll("R$ ", "")
            ?.replaceAll(".", "")
            ?.replaceAll(",", ".")
        ),
        auth_strat_id: this.strategyInfo?.auth_strat_id,
        user_code: this.getSelectedAccount.account_type === "PRD" ? this.userPin : undefined,
      };
    },
    hasSelectedFromList() {
      return (
        this.formFields
          .find((item) => item.label === "Estratégia")
          .searchResults.findIndex((item) => item.value === this.getValue("Estratégia")) !== -1
      );
    },
    searchValue() {
      return this.formFields[0].value;
    },
  },

  methods: {
    normalize(item) {
      if (item.hasOwnProperty("max") && item.hasOwnProperty("min")) {
        if (item.value > item.max) {
          item.value = item.max;
        } else if (item.value < item.min) {
          item.value = item.min;
        }
      }
    },
    getValue(label) {
      return this.formFields.find((item) => item.label === label)?.value;
    },
    confirm() {
      if (this.getSelectedAccount.account_type === "PRD" && !this.userPinModalIsActive) {
        this.userPinModalIsActive = true;
      } else {
        this.createAuth();
      }
    },
    createAuth() {
      this.$api
        .post(this.$endpoint.AUTH_CREATE, this.valuesToSend)
        .then((res) => {
          console.log(res.data);
          this.$swal("Sucesso", res.data.msg.charAt(0).toUpperCase() + res.data.msg.slice(1), "success").then(() => {
            this.$router.push({ name: "Pré-autorização Long & Short" });
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        });
    },
    searchPartners(partner_name) {
      if (partner_name?.length >= 3) {
        this.$api
          .get(this.$endpoint.SEARCH_AUTH_STRATEGIES, {
            params: {
              chars: partner_name,
            },
          })
          .then((res) => {
            this.formFields.find((item) => item.label === "Estratégia").searchResults = res.data.map((item) => {
              return {
                label: item.strategy_name,
                value: item.strategy_code,
              };
            });
            this.results = res.data;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },

  watch: {
    searchValue: {
      handler(newValue) {
        this.searchPartners(newValue);
      },
    },
    strategyInfo: {
      handler(val) {
        let options = [];
        for (let i = 1; i <= val.strategy_max_positions; i++) {
          options.push(i);
        }
        let index = this.formFields.findIndex((item) => item.label === "Limite máximo de operações simultâneas:");
        this.$set(this.formFields, index, {
          ...this.formFields[index],
          options,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  @apply border-ontick-steel-300 dark:bg-ontick-graphite-500 dark:disabled:bg-ontick-steel-500 h-10 w-full rounded border-2 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border disabled:bg-gray-400 dark:border-0 dark:disabled:text-gray-500;
}
</style>
